module.exports = __webpack_public_path__ + "img/jacob-ellenhard_h.jpg.450631a8.webp";